import axios from 'axios';

const getIndicadores = params => axios.get('/indicadores/comprador/indicadores', { params });
const getIndicadoresCompras = params => axios.get('/indicadores/comprador/indicadores/compras', { params });
const getIndicadoresRequisicoes = params => axios.get('/indicadores/comprador/indicadores/requisicoes', { params });
const getSavings = params => axios.get('/indicadores/comprador/savings', { params });
const getCompras = params => axios.get('/indicadores/comprador/compras', { params });
const getComprasPorCentroCusto = params => axios.get('/indicadores/comprador/indicadores/compras/centros-custos', { params });
const getComprasPorProjeto = params => axios.get('/indicadores/comprador/indicadores/compras/projetos', { params });
const getComprasTotais = params => axios.get('/indicadores/comprador/compras/totais', { params });
const getComprasPage = params => axios.get('/indicadores/comprador/compras/page', { params });
const getComprasPrazoMedio = params => axios.get('/indicadores/comprador/compras/pmp', { params });

export default {
  getIndicadores,
  getSavings,
  getCompras,
  getIndicadoresCompras,
  getComprasTotais,
  getIndicadoresRequisicoes,
  getComprasPorCentroCusto,
  getComprasPorProjeto,
  getComprasPage,
  getComprasPrazoMedio,
};
